exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_image_3OtYd1VI-3rKe5Ywuu_weZ {\n  width: 100%;\n  float: left;\n  clear: both;\n  margin-bottom: 20px;\n}\n\n.IA_dropZones_2obDPGHX80ynnZlJslge4Y {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n}", ""]);

// Exports
exports.locals = {
	"IA_image": "IA_image_3OtYd1VI-3rKe5Ywuu_weZ",
	"IA_dropZones": "IA_dropZones_2obDPGHX80ynnZlJslge4Y"
};